// function that handles adobe syncing upon cancellation
import axios from "axios";
import { getUserEmail } from "./utils";

export const syncAdobeStatus = async (record_id: string | null) => {
  const getLoginDetails = sessionStorage?.getItem("profile");

  if (getLoginDetails) {
    const loginUserEmail = getUserEmail();

    const apiUrl = `${process.env.REACT_APP_PROXY_URL}/v1/syncAdobeStatus`;
    const response = await axios.post(apiUrl, null, {
      headers: {
        Authorization: "Basic " + process.env.REACT_APP_AUTHORIZATION_KEY,
        "x-merck-apikey": process.env.REACT_APP_X_MERCK_API_KEY,
      },
      params: {
        record_id,
        email: loginUserEmail ?? "",
      },
    });
    return response?.data?.status;
  }

  return null;
};
